function convertSecondsToMinutes(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes} min ${remainingSeconds} sec`;
}

function QuestionNumber({question , index}) {
  return (
    <div className="flex justify-between items-center border-b-4 border-neutral pb-1 mb-4">
        <h2 className="text-2xl font-bold text-gray-700">Question {index + 1}:</h2>
        <div className="flex gap-8">
            <div className="text-right">
            <p className="text-gray-500 text-sm">Marks</p>
            <p className="font-bold">{question.obtainedScore}/{question.maxScore}</p>
            </div>
            <div className="text-right">
            <p className="text-gray-500 text-sm">Total Time</p>
            <p className="font-bold">{convertSecondsToMinutes(question.expectedTimeToSolveForStudent)}</p>
            </div>
            <div className="text-right">
            <p className="text-gray-500 text-sm">Time Taken</p>
            <p className="font-bold">{convertSecondsToMinutes(question.timeTakenByStudent)}</p>
            </div>
        </div>
    </div>
  )
}

export default QuestionNumber